module.exports = __webpack_public_path__ + "img/Lan50.594effd0.svg";